import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Reciters from "../components/quraan/reciters";
import Narrations from "../components/quraan/riwaya";
import NarrationAudioList from "../components/quraan";
import { baseUrl } from "../shared/baseUrl";

function Quraan({ queue, setQueue, setCurrent, setPlaying, liked, setLiked }) {
  const [reciters, setreciters] = useState([]);
  const [search, setSearch] = useState("");

  const navigate = useNavigate();
  const { reciterSlug, narrationSlug } = useParams();

  // ✅ FIND reciter USING SLUG (NO EXTRA API)
  const selectedreciter = reciterSlug
    ? reciters.find((reciter) => reciter.slug === reciterSlug)
    : null;

  // ✅ FIND narration FROM ALREADY-LOADED DATA
  const selectednarration =
    narrationSlug && selectedreciter
      ? selectedreciter.riwaayah.find(
          (narration) => narration.slug.toString() === narrationSlug,
        )
      : null;

  useEffect(() => {
    fetch(baseUrl + "api/v1/recitations")
      .then((res) => res.json())
      .then((data) => setreciters(Array.isArray(data) ? data : []))
      .catch(() => setreciters([]));
  }, []);

  // ✅ NAVIGATION USING SLUG
  const openreciter = (reciter) => navigate(`/reciter/${reciter.slug}`);

  const opennarration = (narration) =>
    navigate(`/narration/${selectedreciter.slug}/${narration.slug}`);

  // 🔍 SEARCH
  const filteredreciters = reciters.filter((reciter) =>
    reciter.name.toLowerCase().includes(search.toLowerCase()),
  );

  // 🎵 narration AUDIO
  if (selectednarration) {
    return (
      <NarrationAudioList
        narration={selectednarration}
        reciter={selectedreciter}
        goBack={(to) => {
          if (to === "home") navigate("/");
          if (to === "reciter") navigate(`/reciter/${selectedreciter.slug}`);
        }}
        queue={queue}
        setQueue={setQueue}
        setCurrentAudio={setCurrent}
        setPlaying={setPlaying}
        liked={liked}
        setLiked={setLiked}
      />
    );
  }

  // 🎤 reciter narrationS
  if (selectedreciter) {
    return (
      <Narrations
        reciter={selectedreciter}
        onnarrationClick={opennarration}
        goBack={() => navigate("/")}
      />
    );
  }

  // 🏠 HOME (reciterS LIST)
  return (
    <>
      <div className="search-input">
        <input
          type="text"
          placeholder="Search reciters..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <Reciters reciters={filteredreciters} onreciterClick={openreciter} />
    </>
  );
}

export default Quraan;
